import React from 'react';
import { Link } from 'react-router-dom';
import 'iconify-icon';
import { resolveState } from '../../data/brazil-state-centroids';

export const FranchiseHero = ({ franchise, wppLink }) => {
  const {
    name, legal_name, state, city, contact_email, instagram, instagram_handles = [],
    cities_served = [], format: formatType, coverage_description,
  } = franchise;

  const stateMeta = resolveState(state);
  const cities = cities_served.length ? cities_served : [city].filter(Boolean);
  const allIgs = instagram_handles?.length ? instagram_handles : (instagram ? [instagram] : []);

  return (
    <section
      className="relative pt-32 pb-14 border-b border-neutral-900"
      style={{ background: 'rgba(10, 10, 10, 0.78)' }}
      data-testid="franchise-hero"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12">
        <Link
          to="/franquias"
          className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-neutral-500 hover:text-accent-orange mb-8 transition-colors"
        >
          <iconify-icon icon="solar:arrow-left-linear"></iconify-icon>
          Voltar ao localizador
        </Link>
        <div className="flex flex-wrap gap-2 mb-4 text-[10px] font-mono uppercase tracking-wider">
          <span className="px-3 py-1 bg-accent-orange text-white rounded-full">
            {stateMeta?.code || state}
          </span>
          {city && (
            <span className="px-3 py-1 bg-[#1A1A1A] border border-[#333333] text-neutral-300 rounded-full">
              {city}
            </span>
          )}
          {formatType && (
            <span className="px-3 py-1 bg-[#1A1A1A] border border-[#333333] text-neutral-300 rounded-full">
              {formatType}
            </span>
          )}
        </div>
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-[#EAEAEA] mb-4">
          {name || `IE ${city}`}
        </h1>
        {coverage_description && (
          <p
            className="text-accent-orange text-sm md:text-base font-medium mb-3"
            data-testid="franchise-hero-coverage"
          >
            {coverage_description}
          </p>
        )}
        {legal_name && <p className="text-neutral-500 text-sm mb-6">{legal_name}</p>}
        <p className="text-lg text-neutral-400 max-w-3xl mb-8">
          Atendendo {cities.length} {cities.length === 1 ? 'cidade' : 'cidades'}:{' '}
          <strong className="text-[#EAEAEA]">{cities.join(' · ')}</strong>
        </p>

        <div className="flex flex-wrap gap-3">
          <a
            href={wppLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="franchise-cta-whatsapp"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-orange text-white rounded-full text-sm font-bold uppercase tracking-wider hover:bg-[#E55D00] transition-colors"
          >
            <iconify-icon icon="mdi:whatsapp" className="text-lg"></iconify-icon>
            Falar pelo WhatsApp
          </a>
          {contact_email && (
            <a
              href={`mailto:${contact_email}`}
              data-testid="franchise-cta-email"
              className="inline-flex items-center gap-2 px-6 py-3 border border-[#333333] text-[#EAEAEA] rounded-full text-sm font-bold uppercase tracking-wider hover:border-accent-orange hover:text-accent-orange transition-colors"
            >
              <iconify-icon icon="solar:letter-linear" className="text-lg"></iconify-icon>
              E-mail
            </a>
          )}
          {allIgs.map((ig) => (
            <a
              key={ig}
              href={`https://instagram.com/${ig.replace('@', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 border border-[#333333] text-[#EAEAEA] rounded-full text-sm font-bold uppercase tracking-wider hover:border-accent-orange hover:text-accent-orange transition-colors"
            >
              <iconify-icon icon="mdi:instagram" className="text-lg"></iconify-icon>
              {ig}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
